import { Banner } from './../models/banners_model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RouteInfo } from 'src/app/shared/sidebar/sidebar.metadata';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OpAdminBannersAndOffersService {

  constructor(private http: HttpClient) { }
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  getAllUser(pageId) {
    let url = environment.URL + "/banner/getall/null?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveBannersAndOffersRecordById(categoryId) {
    let url = environment.URL + "/banner/edit/" + categoryId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveBannersAndOffers(formData) {
    let url = environment.URL + "/banner/create";
    return this.http.post(url, formData);
  }

  updateBannersAndOffers(formData) {
    let url = environment.URL + "/banner/update";
    return this.http.post(url, formData);
  }

  deleteBannersAndOffers(bodyParams: Banner) {
    let url = environment.URL + "/banner/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url = environment.URL + "/banner/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getProductList() {
    let url = environment.URL + "/banner/productList";
    return this.http.get(url, { headers: this.myHeaders });
  }

  getCategoryList() {
    let url = environment.URL + "/categories/getall/";
    return this.http.get(url, { headers: this.myHeaders });
  }

  getCodeList(moduleName){
    let url = environment.URL + "/code/" + moduleName;
    return this.http.get(url, { headers: this.myHeaders });
  }
  uploadOfferLogo(formData){
    let url = environment.URL + "/uploadOffer";
    return this.http.post(url, formData);
  }
}
